import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import type { AccessKind } from '@/types'

declare module 'vue-router' {
  interface RouteMeta {
    access?: AccessKind
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/mini-products'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/mini-products',
    name: 'MiniProducts',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'dashboard' },
    children: [
      {
        path: '',
        name: 'MiniProductsHome',
        component: () => import('@/views/MiniProducts.vue')
      }
    ]
  },
  {
    path: '/admin/products',
    name: 'ProductsAdmin',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'dashboard' },
    children: [
      {
        path: '',
        name: 'ProductsAdminHome',
        component: () => import('@/views/ProductsAdmin.vue')
      }
    ]
  },
  {
    path: '/admin/campaigns',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'dashboard' },
    children: [
      {
        path: '',
        name: 'CampaignsAdmin',
        component: () => import('@/views/CampaignsAdmin.vue')
      }
    ]
  },
  {
    path: '/admin/way4pay-accounts',
    name: 'Way4PayAccounts',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'dashboard' },
    children: [
      {
        path: '',
        name: 'Way4PayAccountsHome',
        component: () => import('@/views/Way4PayAccounts.vue')
      }
    ]
  },
  {
    path: '/admin/stripe-accounts',
    name: 'StripeAccounts',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'dashboard' },
    children: [
      {
        path: '',
        name: 'StripeAccountsHome',
        component: () => import('@/views/StripeAccounts.vue')
      }
    ]
  },
  {
    path: '/igroshcola',
    name: 'Igroshcola',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'dashboard' },
    children: [
      {
        path: '',
        name: 'IgroshcolaHome',
        component: () => import('@/views/Igroshcola.vue')
      }
    ]
  },
  {
    path: '/settings/users',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'admin' },
    children: [
      {
        path: '',
        name: 'SettingsUsers',
        component: () => import('@/views/settings/Users.vue')
      }
    ]
  },
  {
    path: '/renewals',
    component: () => import('@/layouts/RenewalsLayout.vue'),
    meta: { access: 'renewals' },
    children: [
      {
        path: '',
        name: 'Renewals',
        component: () => import('@/views/renewals/RenewalsList.vue')
      }
    ]
  },
  {
    path: '/club',
    name: 'Club',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { access: 'dashboard' },
    children: [
      {
        path: '',
        name: 'ClubHome',
        component: () => import('@/views/Club.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Доступы приходят с бэкенда (/auth/me); первый переход ждёт их загрузки
router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.load()

  if (to.path === '/login') {
    if (auth.has('dashboard')) return '/mini-products'
    if (auth.has('renewals')) return '/renewals'
    return true
  }

  const access = to.meta.access
  if (!access) return true
  if (!auth.isAuthenticated) return { path: '/login', query: { redirect: to.fullPath } }
  if (auth.has(access)) return true
  // Сессия есть, но этого доступа нет: старосту с "/" уводим на её страницу
  if (auth.has('renewals')) return '/renewals'
  if (auth.has('dashboard')) return '/mini-products'
  // Админ мог сам выключить себе оба обычных доступа на странице пользователей —
  // не отправлять его на страницу "заявка принята", у него есть своя страница
  if (auth.has('admin')) return '/settings/users'
  return { path: '/login', query: { pending: '1' } }
})

export default router
